<template>
  <div v-if="state" class="web-camera-container">
    <div v-show="isCameraOpen && isLoading" class="camera-loading">
      <ul class="loader-circle">
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>

    <div
      v-if="isCameraOpen"
      v-show="!isLoading"
      class="camera-box"
      :class="{ flash: isShotPhoto }"
    >
      <div class="camera-shutter" :class="{ flash: isShotPhoto }"></div>

      <video id="liveCam" v-show="!isPhotoTaken" ref="camera" autoplay></video>

      <canvas
        v-show="isPhotoTaken"
        id="photoTaken"
        ref="canvas"
        :width="canvasWidth"
        :height="canvasHeight"
      ></canvas>
    </div>

    <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
      <button
            type="button"
            class="button"
            @click="takePhoto"
          >
            <i class="fas fa-camera"></i>
          </button>
    </div>

    
    <div v-if="isPhotoTaken && isCameraOpen" class="row w-100">
        <div class="mx-auto mt-3 col-6">
      <button class="btn btn-primary"
        role="button"
        @click="uploadImage"
      >
        Upload
      </button>
        </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
export default {
  name: "Camera",
  components: {},
  props: ["state", "capturedState", "user"],
  data() {
    return {
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      link: "#",
      canvasHeight: 300,
      canvasWidth: 400,
    };
  },
  methods: {
    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },

    createCameraElement() {
      this.isLoading = true;

      const constraints = (window.constraints = {
        audio: false,
        video: true,
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.isLoading = false;
          this.$refs.camera.srcObject = stream;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("May the browser didn't support or there is some errors.");
        });
    },

    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach((track) => {
        track.stop();
      });
    },

    async takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;
        const photo = document.getElementById("liveCam");
        console.log(photo.offsetHeight);
        this.canvasWidth = photo.offsetWidth;
        this.canvasHeight = photo.offsetHeight;
        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      setTimeout(() => {
        const context = this.$refs.canvas.getContext("2d");
        context.drawImage(
          this.$refs.camera,
          0,
          0,
          this.canvasWidth,
          this.canvasHeight
        );
      }, 100);
      this.isPhotoTaken = !this.isPhotoTaken;
      this.$emit('captured', this.isPhotoTaken)

    },

    async uploadImage() {
      const download = document.getElementById("downloadPhoto");
      const canvas = document
        .getElementById("photoTaken")
        .toDataURL("image/jpeg")
        // .replace("image/jpeg", "image/octet-stream");
    //   download.setAttribute("href", canvas);
    const storageRef = firebase.storage().ref('users/' + this.user.uid + '/profile.jpg')
    await storageRef.putString(canvas, 'data_url').then(function(){
        console.log('Uploaded succesfully')
    }).catch(error =>{
        console.log(error.message)
    })
    this.toggleCamera()
    this.$emit('uploaded', true)
    },
  },

  watch: {
    state: function (val) {
      if (val === true) {
        this.toggleCamera();
      } else if (val === false) {
        this.toggleCamera();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.web-camera-container {
  margin-top: 2rem;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  .btn{
      width: 100%;
  }

  .camera-button {
    margin-bottom: 2rem;
  }

  .camera-box {
    #liveCam {
      width: 100%;
    }

    .camera-shutter {
      opacity: 0;
      width: 100%;
      background-color: #fff;
      position: absolute;

      &.flash {
        opacity: 1;
      }
    }
  }

  .camera-shoot {
    margin-top: -30px;
    z-index: 1;

    button {
      height: 60px;
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;

      img {
        height: 35px;
        object-fit: cover;
      }
    }
  }

  .camera-loading {
    overflow: hidden;
    height: 100%;
    position: absolute;
    width: 100%;
    min-height: 150px;
    margin: 3rem 0 0 -1.2rem;

    ul {
      height: 100%;
      position: absolute;
      width: 100%;
      z-index: 999999;
      margin: 0;
    }

    .loader-circle {
      display: block;
      height: 14px;
      margin: 0 auto;
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      transform: translateX(-50%);
      position: absolute;
      width: 100%;
      padding: 0;

      li {
        display: block;
        float: left;
        width: 10px;
        height: 10px;
        line-height: 10px;
        padding: 0;
        position: relative;
        margin: 0 0 0 4px;
        background: #999;
        animation: preload 1s infinite;
        top: -50%;
        border-radius: 100%;

        &:nth-child(2) {
          animation-delay: 0.2s;
        }

        &:nth-child(3) {
          animation-delay: 0.4s;
        }
      }
    }
  }

  @keyframes preload {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }
}
</style>